<modal-container
  #modal
  [headerIconClass]="'far-file-export'"
  [headerTitle]="isInFilterForm ? 'exports.hs-products' : 'exports.orders'"
  [isLargeModal]="isInFilterForm"
  [isExtraLargeModal]="!isInFilterForm"
>
  <ng-container class="modal-button-show">
    <btn
      [btnType]="'button'"
      [icon]="'far-download'"
      (click)="showChildModal()"
      [label]="isInFilterForm ? 'export.create' : 'export.orders'"
      [title]="isInFilterForm ? ('export.create' | translate) : ('export.orders' | translate)"
      [classes]="['btn-third']"
      data-cy="export"
    ></btn>
  </ng-container>

  <ng-container class="modal-body-content" *ngIf="isInFilterForm">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      <div class="product-search-form mb-2">
        <form-row-select [label]="'type'" [options]="types" [(model)]="type"></form-row-select>
      </div>
      <form-row-input
        *ngIf="entity === 'hs-products' && ['hs-product-depots', 'hs-products'].includes(type)"
        [label]="'export.date'"
        [inputType]="'date'"
        [icon]="null"
        [(model)]="date"
      ></form-row-input>
      <div class="yellow-background explanation-box d-flex">
        <i class="fal fa-info-circle yellow mr-2"></i>
        <p class="overflow-auto">{{ 'export.explanation.' + type | translate }}</p>
      </div>
      <div class="product-search-form mb-2">
        <form-row-textarea [label]="'note'" [(model)]="note" data-cy="export-note"></form-row-textarea>
      </div>
    </div>
  </ng-container>

  <ng-container class="modal-body-content" *ngIf="!isInFilterForm">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      <div class="d-flex justify-content-between product-search-form mb-2">
        <form-row-select
          class="width-24"
          [label]="'supplier'"
          [options]="suppliers"
          [model]="supplier"
          (modelChange)="supplier = Number($event)"
          data-cy="export-note"
        >
        </form-row-select>
        <form-row-select class="width-24" [label]="'depot'" [options]="depots" [(model)]="depot"> </form-row-select>
        <form-row-select class="width-12" [label]="'type'" [options]="fileTypes" [(model)]="type"> </form-row-select>
        <form-row-select class="width-12" [label]="'withPrice'" [options]="withPricesOptions" [(model)]="withPrices">
        </form-row-select>
        <form-row-checkbox
          class="width-20 align-self-center"
          [label]="'exports.all.into.one.file'"
          [(ngModel)]="allIntoOneFile"
          [name]="'exports.all.into.one.file'"
        ></form-row-checkbox>
      </div>
      <div class="flex-gap-1 align-items-baseline">
        <btn
          [label]="'generate'"
          [title]="'generate' | translate"
          [icon]="'far-file-export'"
          [classes]="['btn-first', 'mb-2']"
          [btnDisabled]="loading || (isInFilterForm && !type) || (!isInFilterForm && !depot)"
          (onEvent)="generate()"
          data-cy="export-create"
        ></btn>
        <p>{{ 'export.suppliers.will.be.skipped.warning' | translate }}</p>
      </div>
      <app-base-listing
        [storageKey]="storageKey"
        [loadingNextItems]="loading"
        [loadingItems]="loading"
        [items]="exports"
        [columns]="listingColumns"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [endPage]="endPage"
        [(sortProp)]="defaultFilters.sortProp"
        [(sortDir)]="defaultFilters.sortDir"
        (reloadList)="filter(1)"
        (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
        (callAction)="callAction($event)"
      ></app-base-listing>
    </div>
  </ng-container>

  <ng-container class="modal-footer-content" *ngIf="isInFilterForm">
    <btn
      [label]="'create'"
      [title]="'create' | translate"
      [icon]="'far-file-export'"
      [classes]="['btn-first']"
      [btnDisabled]="loading || !type"
      (onEvent)="createExportWithFilters()"
      data-cy="export-create"
    ></btn>
  </ng-container>
</modal-container>
